/*
* Open/close menu
*/
class ST_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.menu-bar');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menuList = this.menuWrapper.find('.menu-list');
        this.menuItem = this.menuWrapper.find('.menu-item');
        this.menuItemSubmenu = this.menuWrapper.find('.has-submenu');
        this.mobileViewport = window.matchMedia("screen and (max-width: 1040px)");
    }

    initEvents() {
        this.menuItemSubmenu.append( "<span class='arrow'></span>" );

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                this.menuList.css('display', 'flex');
                this.menuIcon.toggleClass('is-open');
                $(document.body).toggleClass('no-scroll');
    
                setTimeout(() => {
                    this.menuList.toggleClass('is-active');
                }, 250);
            });
    
            this.menuItem.on('click', () => {
                if ($(window).outerWidth() <= 1040) {
                    this.menuIcon.removeClass('is-open');
                    this.menuList.removeClass('is-active');
                    $(document.body).removeClass('no-scroll');
    
                    setTimeout(() => {
                        this.menuList.css('display', 'none');
                    }, 250);
                }
            });
        }
    
        if(this.mobileViewport.matches) {
            setTimeout(() => {
                this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');
                
                this.menuSubmenuToggle.each(function(i, item) {
                    $(item).on('click', (e) => {
                        e.stopPropagation();
                        $(item).parent().toggleClass('is-active');
                    });
                });
            }, 0);
        }
    }
}